import React, { Component } from 'react';
import { ReactComponent as CargoInfo } from 'Icons/cargoinfo.svg';
import Select from 'react-select';
import { SingleDatePicker } from 'react-dates';
import TimePicker from 'rc-time-picker';
import Moment from 'moment';
import Input from 'Components/Input/index';
import {
    METRIC_SYSTEM,
    CARGO_PARTICULARS, 
    UOM_CARGO_PACKING_TYPE, 
    METRIC_SYSTEM_CONVERSION
} from 'Constants/commonConstants';
import ConfirmationPopup from 'Components/ConfirmationPopup';
import Checkbox from 'Components/Checkbox/index';
import { ReactComponent as PlusIcon } from 'Icons/plus.svg';
import { ReactComponent as CloseIcon } from 'Icons/close-circle.svg';
import { ReactComponent as CopyIcon } from 'Icons/copy.svg';
import Dropdown from 'Components/Dropdown/index';

class ContainerDetails extends Component {
    constructor(props) {
        super(props);
        this.trip = props.trip;
        if(this.trip.cargoParticularList.length === 0) {
            this.trip.cargoParticularList.push(JSON.parse(JSON.stringify(CARGO_PARTICULARS)))
        }
        this.state = {
            activeView: 1,
            trip: this.trip,
            vehicleCopy: []
        }
        this.viewMode = props.viewMode;
    }

    setVehicleType = (vehicleType)=> {
        if(this.viewMode) {
            return;
        }
        const { trip } = this.state;
        trip.vehicleType = vehicleType.value;
        trip.vehicleTypeName = vehicleType.name;
        trip.carryingCapacity = vehicleType.carrying_capacity;
        trip.requiredVehicleCapacity = vehicleType.vehicle_capacity_MT;
        trip.vehicleCapacity = vehicleType.vehicle_capacity;
        this.trip.setVehicleType(vehicleType.value, vehicleType.name);
        this.trip.setRequiredVehicleCapacity(vehicleType.vehicle_capacity_MT);
        this.trip.setVehicleCapacity(vehicleType.vehicle_capacity);
        this.trip.setSAPVehicleId(vehicleType.sap_mapping_id);
        this.setState({ trip });
        this.props.onChange()
    }

    setVehicleBodyType = (vehicleBodyType)=> {
        if(this.viewMode) {
            return;
        }
        const { trip } = this.state;
        trip.vehicleBodyType = vehicleBodyType.value;
        trip.vehicleBodyTypeName = vehicleBodyType.name;
        this.trip.setVehicleBodyType(vehicleBodyType.value, vehicleBodyType.name);
        this.setState({ trip });

        this.props.onChange()
    }

    onChangeRemarks = (e)=> {
        const { trip } = this.state;
        trip.remarks = e.target.value;
        this.trip.setRemarks(e.target.value);
        this.setState({ trip });
        this.props.onChange()
    }

    onAddNoOfContainers = (e) => {
        this.trip.setNoOfContainers(e.target.value);
        // if((this.trip.legs || []).length > 0) {
        //     const isSea = ((rfq.rfqDetails || {}).serviceCategoryType === 1);
        //     const isLCL = ((rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType === 5);
        //     const chargableWeight = ((this.trip.cargoParticularList || []).reduce((sum, el) => sum += Number(el.chargableWeight || 0),0));
        //     (this.trip.legs || []).forEach((leg, index) => {
        //         if(((rfq.rfqDetails || {}).serviceCategoryType === 1 ? (rfq.rfqDetails || {}).serviceType === 5 : true)) {
        //             this.trip.legs[index].setBusinessVolumeUnit(this.trip.metricSystem === 1 ? (((rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType === 5) ? { value: 11, name: "Per Cubic Meter"} : { value: 2, name: "Kilograms (KGs)"}) : { value: 12, name: "Pounds"});
        //             this.trip.legs[index].setBusinessVolumeValue(chargableWeight)
        //         } else if(isSea && (rfq.rfqDetails || {}).serviceType !== 5) {
        //             this.trip.legs[index].setBusinessVolumeUnit({ value: 8, name: "Container Load" });
        //             this.trip.legs[index].setBusinessVolumeValue((this.trip || {}).noOfContainers || 1);
        //         }
        //         (this.trip.legs[index].multiModeHeadingCharges || []).forEach((hc, hcIndex) => {
        //             if(((rfq.rfqDetails || {}).serviceCategoryType === 1 ? (rfq.rfqDetails || {}).serviceType === 5 : true)) {
        //                 this.trip.legs[index].multiModeHeadingCharges[hcIndex].headingChargesBusinessVolumeValue =  (chargableWeight);
        //                 this.trip.legs[index].multiModeHeadingCharges[hcIndex].headingChargesBusinessVolumeUnit = this.trip.metricSystem === 1 ? (isLCL ? 11 : 2) : 12;
        //                 this.trip.legs[index].multiModeHeadingCharges[hcIndex].headingChargesBusinessVolumeUnitName = this.trip.metricSystem === 1 ? (isLCL ? "Per Cubic Meter" : "Kilograms (KGs)") : 'Pounds';
        //             } else if(isSea && (rfq.rfqDetails || {}).serviceType !== 5) {
        //                 this.trip.legs[index].multiModeHeadingCharges[hcIndex].headingChargesBusinessVolumeValue = (this.trip || {}).noOfContainers || 1;
        //                 this.trip.legs[index].multiModeHeadingCharges[hcIndex].headingChargesBusinessVolumeUnit = 8;
        //                 this.trip.legs[index].multiModeHeadingCharges[hcIndex].headingChargesBusinessVolumeUnitName = "Container Load";
        //             }
        //         })
        //     })
        // }
        this.setState({
            trip: this.trip
        });
        this.props.onChange('isChange')
    }

    changeMetricSystem = (value, isConfirm) => {
        this.trip.setMetricSystem(value);
        if(isConfirm) {
            (this.trip.cargoParticularList || []).forEach(el => {
                const uomData = UOM_CARGO_PACKING_TYPE.filter(uom => this.trip.metricSystem === 1 ? uom.value !== 3 : uom.value === 3);
                el.uom = uomData[0];
            })
            this.trip.cargoParticularList = this.getVolumeWeight(this.trip.cargoParticularList);
            this.trip.setCargoParticulars(this.trip.cargoParticularList);
        }
        this.setState({
            trip: this.trip,
            isConfirmPopUp: false,
            confirmationData: ''
        });
        this.props.onChange('isChange')
    }

    removeParticulars = (index) => {
        const { trip } = this.state;
        trip.cargoParticularList.splice(index, 1);
        this.trip.setCargoParticulars(trip.cargoParticularList);
        this.setState({
            trip: this.trip
        });
        this.props.onChange('isChange');
    }

    addParticulars = (value, isCopy) => {
        const { trip } = this.state;
        trip.cargoParticularList.push(JSON.parse(JSON.stringify(isCopy ? value : CARGO_PARTICULARS)));
        this.setState({ trip });
    }

    onChangeCargoParticulars = (e, index) => {
        const { name, value } = e.target;
        const { trip } = this.state;
        trip.cargoParticularList[index][name] = value;
        trip.cargoParticularList = this.getVolumeWeight(trip.cargoParticularList);
        this.trip.setCargoParticulars(trip.cargoParticularList);
        this.setState({
            trip: this.trip
        });
        this.props.onChange('isChange');
    }

    getVolumeWeight = (data) => {
        const { rfq } = this.props;
        const isLCL = ((rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType === 5);
        (data || []).forEach(el => {
            
            if(el.quantity && (el.uom || {}).value) {
                const cbmValue = (el.uom || {}).cbm || 1;
                const dimension = ( isLCL ? ((el.length / cbmValue) * (el.height / cbmValue) * (el.breadth/cbmValue)) : (el.length * el.height * el.breadth));
                el.volumeWeight = isLCL ? Number(dimension).toFixed(2) : Number(((dimension) / ((METRIC_SYSTEM_CONVERSION || []).find(msc => (msc.value === (el.uom || {}).value && msc.metricvalue === this.state.trip.metricSystem)) || {}).calValue) * el.quantity).toFixed(2);
                if(!isLCL && el.grossWeight && el.netWeight) {
                    el.chargableWeight = Number(Math.max(el.grossWeight, el.netWeight, el.volumeWeight)).toFixed(2);
                } else if(isLCL) {
                    el.chargableWeight = Number(dimension * el.quantity).toFixed(2);
                }
            }
        })
        return data;
    }

    onSelectCargoParticulars = (name, index, value) => {
        const { trip } = this.state;
        trip.cargoParticularList[index][name] = value;
        trip.cargoParticularList = this.getVolumeWeight(trip.cargoParticularList);
        this.trip.setCargoParticulars(trip.cargoParticularList);
        this.setState({
            trip: this.trip
        });
        this.props.onChange('isChange');
    }

    render() {
        const { 
            vehicleTypes,
            vehicleBodyTypes,
            trip,
            rfq,
            isError
        } = this.props;
        let totalChargableWeight = 0, totalNetWeight = 0, totalGrossWeight = 0, totalVolumeWeight = 0;

        return (
            <div className='vehicleDetails pb-20'>
                <div className='header pv-10 ph-20 border-bottom-light-2'>Add New Trip</div>
                <div className='ph-20'>
                    <div className='mt-20 flex mb-20'>
                            <CargoInfo />
                            <div className='ml-10 header'>Container Details</div>
                    </div>
                    {((rfq.rfqDetails || {}).serviceCategoryType === 1 ? (rfq.rfqDetails || {}).serviceType === 5 : true)  && 
                        <div className="mb-30">
                            <div className="header">
                                Cargo Particulars
                            </div>
                            <div className="flex flex-wrap ml-5 rfqValue">
                                <div className="subHeader mr-20">
                                    Metric System
                                </div>
                                {(METRIC_SYSTEM || []).map(el =>( <Checkbox label={(el.name || '').split('-')[0]} checked = {this.trip.metricSystem === el.value} className="mr-20 mb-5" 
                                    onCheck={() => {
                                    if(this.trip.metricSystem !== el.value &&  (this.trip.cargoParticularList || []).filter(cargo => cargo.volumeWeight && (cargo.uom || {}).value).length > 0) {
                                        this.setState({ isConfirmPopUp: true, confirmationData: el });
                                    } else {
                                        this.changeMetricSystem(el);
                                    }
                                    }}
                                />))}
                            </div>
                            <div className="courier-table mt-5">
                                <table cellPadding={0} cellSpacing={0}>
                                <thead>
                                    <tr>
                                        <th>Sl No.</th>
                                        {/* <th>Metric System</th> */}
                                        <th>Cargo Packing Type</th>
                                        <th>No. of Units</th>
                                        <th width="60">{'Length'}</th>
                                        <th width="60">{'Breadth'}</th>
                                        <th width="60">{'Height'}</th>
                                        <th>UOM</th>
                                        <th>Net Weight</th>
                                        <th>Gross Weight</th>
                                        <th>{((rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType === 5) ? 'Unit Volume(CBM)' : 'Volume Weight'}</th>
                                        <th>{((rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType === 5) ? 'Chargeable Volume(CBM)' : `Chargeable Weight ${this.trip.metricSystem === 1 ? '(kgs)' : '(lb)'}`}</th>
                                        <th width="100">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(this.trip.cargoParticularList || []).map((cParticular, index) =>{
                                        totalChargableWeight += Number(cParticular.chargableWeight || 0);
                                        totalGrossWeight += Number(cParticular.grossWeight || 0);
                                        totalNetWeight += Number(cParticular.netWeight || 0);
                                        totalVolumeWeight += Number(cParticular.volumeWeight || 0);
                                    return(<tr>
                                        <td>{index + 1}</td>
                                        {/* <td style={{ 'borderBottom': '1px solid grey'}}>
                                            <Dropdown 
                                                onSelect={this.onSelectCargoParticulars.bind(this, 'metricSystem', index)}
                                                items={METRIC_SYSTEM} 
                                                selectedItem={METRIC_SYSTEM.find((metric)=> {
                                                    return metric.value === (cParticular.metricSystem || {}).value
                                                })} 
                                                label="Select" 
                                                displayKey="name"
                                            />
                                        </td> */}
                                        <td>
                                            <Input  
                                                placeholder={'Eg.pallet'}  
                                                value={cParticular.cargoPackingType} 
                                                onChange={(e) => this.onChangeCargoParticulars(e, index)} 
                                                name={'cargoPackingType'} 
                                            />
                                        </td>
                                        <td>
                                            <Input  
                                                placeholder={'Eg.20'}  
                                                value={cParticular.quantity} 
                                                onChange={(e) => this.onChangeCargoParticulars(e, index)} 
                                                name={'quantity'} 
                                            />
                                        </td>
                                        <td>
                                            <Input  
                                                placeholder={'Eg.10'}  
                                                value={cParticular.length} 
                                                onChange={(e) => this.onChangeCargoParticulars(e, index)} 
                                                name={'length'} 
                                            />
                                        </td>
                                        <td>
                                            <Input  
                                                placeholder={'Eg.20'}  
                                                value={cParticular.breadth} 
                                                onChange={(e) => this.onChangeCargoParticulars(e, index)} 
                                                name={'breadth'} 
                                            />
                                        </td>
                                        <td>
                                            <Input  
                                                placeholder={'Eg.30'}  
                                                value={cParticular.height} 
                                                onChange={(e) => this.onChangeCargoParticulars(e, index)} 
                                                name={'height'} 
                                            />
                                        </td>
                                        
                                        <td>
                                            <Dropdown 
                                                onSelect={this.onSelectCargoParticulars.bind(this, 'uom', index)}
                                                items={UOM_CARGO_PACKING_TYPE.filter(uom => this.trip.metricSystem === 1 ? uom.value !== 3 : uom.value === 3 )} 
                                                selectedItem={UOM_CARGO_PACKING_TYPE.find((cUOM)=> {
                                                    return cUOM.value === (cParticular.uom || {}).value
                                                })} 
                                                label="Select" 
                                                displayKey="name"
                                            />
                                        </td>
                                        <td>
                                            <Input  
                                                placeholder={'Eg.1000'}  
                                                value={cParticular.netWeight} 
                                                onChange={(e) => this.onChangeCargoParticulars(e, index)} 
                                                name={'netWeight'} 
                                            />
                                        </td>
                                        <td>
                                            <Input  
                                                placeholder={'Eg.2000'}  
                                                value={cParticular.grossWeight} 
                                                onChange={(e) => this.onChangeCargoParticulars(e, index)} 
                                                name={'grossWeight'} 
                                            />
                                        </td>
                                        <td>
                                            <Input  
                                                placeholder={'Eg.1500'}  
                                                value={cParticular.volumeWeight} 
                                                onChange={(e) => this.onChangeCargoParticulars(e, index)} 
                                                name={'volumeWeight'} 
                                            />
                                        </td>
                                        <td>
                                            <Input  
                                                placeholder={'Eg.2000'}  
                                                value={cParticular.chargableWeight} 
                                                onChange={(e) => this.onChangeCargoParticulars(e, index)} 
                                                name={'chargableWeight'} 
                                            />
                                        </td>
                                        <td >
                                            {this.trip.cargoParticularList.length- 1 === index && <PlusIcon onClick={this.addParticulars} className="wt-20 ht-20 bg-theme br-20 border-none curP br-50p mr-5" />}
                                            {this.trip.cargoParticularList.length !== 1 && <CloseIcon onClick={() => this.removeParticulars(index)} className="wt-25 ht-25 curP mr-5 pt-5" />}
                                            <CopyIcon onClick={() => this.addParticulars(cParticular, true)} className="wt-20 ht-20 curP mr-5" />
                                        </td>
                                    </tr>)})}
                                    <tr>
                                        <td colSpan="7"> Total </td>
                                        <td><span>{totalNetWeight}</span></td>
                                        <td><span>{totalGrossWeight}</span></td>
                                        <td><span>{totalVolumeWeight}</span></td>
                                        <td><span>{totalChargableWeight}</span></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                                </table>
                                {/* {totalChargableWeight === 0 && <div className="error-color fs-14 fSemibold op-7 mt-10 ml-5">Please enter all the details</div>} */}
                            </div>
                        </div>
                    }
                    {(rfq.rfqDetails || {}).serviceCategoryType !== 2 && <>
                        <div className='flex'>
                            <div className='col-2 mr-15'>
                                <div className='rfqlabel'>Select Container Type <sup className='error-color fs-14'>*</sup></div>
                                <Select 
                                    onChange={this.setVehicleType}
                                    options={vehicleTypes} 
                                    value={vehicleTypes.find((vehicleType)=> {
                                        return vehicleType.value === this.trip.vehicleType
                                    })} 
                                    getOptionLabel={option => option.name}
                                />
                                {isError && !(this.trip.vehicleType) && <span className="error-color fs-14 fSemibold op-7 ml-5">Please Select The Field</span>}
                            </div>
                            <div className='col-2 ml-15'>
                                <div className='rfqlabel'>Select Container Body Type <sup className='error-color fs-14'>*</sup></div>
                                <Select 
                                    options={vehicleBodyTypes}
                                    value={vehicleBodyTypes.find((vehicleBodyType)=> {
                                        return vehicleBodyType.value === this.trip.vehicleBodyType
                                    })}
                                    onChange={this.setVehicleBodyType}
                                    getOptionLabel={option => option.name}
                                />
                                {isError && !(this.trip.vehicleBodyType) && <span className="error-color fs-14 fSemibold op-7 ml-5">Please Select The Field</span>}
                            </div>
                        </div>
                        <div className='flex mt-20'>
                            <div className='col-2 mr-15'>
                                <div className='rfqlabel'>Select Number Of Containers</div>
                                <Input 
                                    type='number'
                                    value={this.trip.noOfContainers}
                                    onChange={this.onAddNoOfContainers}
                                    name="noOfContainers"
                                    placeholder="No. Of Containers"
                                />
                            </div>
                            <div className='col-2 ml-15 tStart'>
                                <div className='rfqlabel'>Select Placement Time</div>
                                <div className='flex'>
                                    <SingleDatePicker
                                        noBorder={true}
                                        displayFormat={"DD MMM YYYY"}
                                        isOutsideRange={() => false}
                                        hideKeyboardShortcutsPanel={true}
                                        placeholder={"Placement Date"}
                                        numberOfMonths={2}
                                        date={this.trip.placementTime ? Moment(this.trip.placementTime) : ''} 
                                        onDateChange={(placementDate) =>{
                                            if(this.viewMode) {
                                                return;
                                            }
                                            const date = placementDate.format('YYYY-MM-DD') + ' ' + Moment(this.trip.placementTime).format('HH:mm')
                                            this.trip.setPlacementTime(new Date(date).getTime());
                                            this.setState({ trip: this.trip });
                                            this.props.onChange()
                                        }}
                                        focused={this.state.focusedStart} 
                                        onFocusChange={({ focused }) => this.setState({ focusedStart: focused })} 
                                    />
                                    <TimePicker
                                        placeholder={"Placement Time"}
                                        showSecond={false}
                                        value={this.trip.placementTime ? Moment(this.trip.placementTime) : ''}
                                        className="ht-40 wt-150 border-status-bar br-5"
                                        onChange={(placementTime) =>{
                                            if(this.viewMode) {
                                                return;
                                            }
                                            const date = Moment(this.trip.placementTime).format('YYYY-MM-DD') + ' ' + placementTime.format('HH:mm')
                                            this.trip.setPlacementTime(new Date(date).getTime());
                                            this.setState({ trip: this.trip });
                                            this.props.onChange()
                                        }}
                                        format={'h:mm a'}
                                        use12Hours
                                        inputReadOnly
                                    />
                                </div>
                            </div>
                        </div>
                    </>}
                    <div className='mt-20'>
                        <div className='rfqlabel'>Remarks</div>
                        <textarea 
                            className='ht-40 wt-800 border-light br-5'
                            value={this.trip.remarks}
                            onChange={this.onChangeRemarks}
                            name="remarks"
                        />
                    </div>
                </div>
                {this.state.isConfirmPopUp &&
                    <ConfirmationPopup 
                    text={"Are you sure to change the metric system ?"}
                    onCancel={() => this.setState({ isConfirmPopUp: false, confirmationData: ''})}
                    onConfirm={() => this.changeMetricSystem(this.state.confirmationData, true)}
                    />
                }
            </div>
        )
    }
}

export default ContainerDetails;